import { createContext, Dispatch, SetStateAction } from 'react';

import { FormInstance } from 'antd';

import { Feature, SelectOption } from '../../../../../../../../../shared/interfaces';

interface StepThreeFormContextProps {
  stepThreeForm:                      FormInstance<any> | undefined;
  commerceFormValues:                 any;
  setCommerceFormValues:              Dispatch<any>;

  activeKey:                          any;
  setActiveKey:                       Dispatch<SetStateAction<any>>;

  tabs:                               Array<any>;
  setTabs:                            Dispatch<SetStateAction<Array<any>>>;

  newTabIndex:                        { current: number };

  plansByActivityList:                Array<SelectOption>;

  allFeatures:                        Array<{ planCode: string, keyTab: number, features: Array<Feature> }>;
  setAllFeatures:                     Dispatch<SetStateAction<Array<{ planCode: string, keyTab: number, features: Array<Feature> }>>>;

  showModal:                          boolean;
  setShowModal:                       Dispatch<SetStateAction<boolean>>;

  keyTabToDelete:                     number | null;
  setKeyTabToDelete:                  Dispatch<SetStateAction<number | null>>;

  addNewTab:                          (id?: number) => void;
  duplicateTab:                       (id?: number) => void;
  removeTab:                          (id?: any) => void;

  getFeaturesRisks:                   ( planSelected: string, componente: number ) => Promise<Array<Feature>>;
  getListPlansActivity:               () => Promise<void>;

  hasClose:                           boolean | undefined;
  hasOpen:                            boolean | undefined;

  plansByActivityListCopy:            any;
  setPlansByActivityList:             Dispatch<SelectOption[]>;
  resetTabs:                          () => void;
}

export const StepThreeFormContext = createContext(
  {} as StepThreeFormContextProps
);
